export enum WEBVIEW_MESSAGE_TYPE {
  PDP_NAVIGATION = 'PDP_NAVIGATION',
  REDIRECT_TO_LOGIN_PAGE = 'REDIRECT_TO_LOGIN_PAGE',
  SEE_ALL = 'SEE_ALL',
  NAVIGATE_PDP_PAGE = 'NAVIGATE_PDP_PAGE',
  ADD_TO_BASKET = 'ADD_TO_BASKET',
  BASKET_ITEMS = 'BASKET_ITEMS',
  CLOSE = 'CLOSE',
  GO_BACK = 'GO_BACK',
  IMAGE_SEARCH_QUERY = 'IMAGE_SEARCH_QUERY',
  BARCODE_SCAN_QUERY = 'BARCODE_SCAN_QUERY',
}

export enum IFRAME_POSTMESSAGE_TYPE {
  SCROLL_TO_TOP = 'SCROLL_TO_TOP',
  SET_HEIGHT = 'SET_HEIGHT',
  SET_QUERY = 'SET_QUERY',
  SET_AUTO_CORRECT = 'SET_AUTO_CORRECT',
  PAGE_CHANGED = 'PAGE_CHANGED',
  FILTER_EVENT = 'FILTER_EVENT',
  UPDATE_MULTI_SEARCH_DATA = 'UPDATE_MULTI_SEARCH_DATA',
  IFRAME_READY = 'IFRAME_READY',
  CART_ITEM_CHANGED = 'CART_ITEM_CHANGED',
  CART_UPDATED = 'CART_UPDATED',
  PRODUCT_ITEM_CHANGED = 'PRODUCT_ITEM_CHANGED',
  UPDATE_CART = 'UPDATE_CART',
  PARENT_QUERY_CHANGED = 'PARENT_QUERY_CHANGED',
  FILTER_CHANGED = 'FILTER_CHANGED',
  FILTER_URL = 'FILTER_URL',
  SET_AUTO_COMPLETE_HEIGHT = 'SET_AUTO_COMPLETE_HEIGHT',
  SEARCH_QUERY_UPDATED = 'SEARCH_QUERY_UPDATED',
  CLOSE_SEARCH_POPPER = 'CLOSE_SEARCH_POPPER',
}
